import { render, staticRenderFns } from "./GiftDialog.vue?vue&type=template&id=caf0637c"
import script from "./GiftDialog.vue?vue&type=script&lang=js"
export * from "./GiftDialog.vue?vue&type=script&lang=js"
import style0 from "./GiftDialog.vue?vue&type=style&index=0&id=caf0637c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports